import { createEvent, createStore, sample } from 'effector'
import { portalRedirectModel } from '~/features/portal/redirect'
import { noop } from '~/shared/helpers'

export const showUpgradePackageWidget = createEvent<string | number>()
export const hideUpgradePackageWidget = createEvent()

sample({
  clock: showUpgradePackageWidget,
  fn: noop,
  target: portalRedirectModel.getPortalAccountAccessTokenFx,
})

export const $showUpgradePackageWidget = createStore(false)
  .on(showUpgradePackageWidget, () => true)
  .on(hideUpgradePackageWidget, () => false)

export const $selectedQuality = createStore<string | number | null>(null)
  .on(showUpgradePackageWidget, (current, quality) => quality ?? current)
  .on(hideUpgradePackageWidget, () => null)
